/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sample_Data_NoteInputs */

const th_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีข้อมูลใดในหน้านี้เป็นข้อมูลจริง เป็นเพียงตัวอย่างของฟีเจอร์ที่ยังไม่มีข้อมูลรองรับ`)
};

const en_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing on this screen is real — it is a preview of a feature that has no data behind it yet.`)
};

const ja_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この画面の内容はすべて架空です。まだデータのない機能のプレビューです。`)
};

const zh_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此屏幕上的内容都不是真实的——这是一项尚无数据支撑的功能预览。`)
};

const es_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada de lo que hay en esta pantalla es real: es una vista previa de una función que aún no tiene datos detrás.`)
};

const pt_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada nesta tela é real — é uma prévia de um recurso que ainda não tem dados por trás.`)
};

const id_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada yang nyata di layar ini — ini pratinjau fitur yang datanya belum ada.`)
};

const fr_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien sur cet écran n’est réel — c’est un aperçu d’une fonctionnalité qui n’a pas encore de données derrière elle.`)
};

const tl_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang totoo sa screen na ito — preview ito ng feature na wala pang datos sa likod.`)
};

const vi_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không gì trên màn hình này là thật — đây là bản xem trước của một tính năng chưa có dữ liệu.`)
};

const ko_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 화면의 어떤 것도 실제가 아닙니다 — 아직 데이터가 없는 기능의 미리보기입니다.`)
};

const de_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts auf diesem Bildschirm ist echt — es ist die Vorschau einer Funktion, hinter der noch keine Daten stehen.`)
};

const ru_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ничто на этом экране не настоящее — это предпросмотр функции, за которой пока нет данных.`)
};

const tr_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu ekrandaki hiçbir şey gerçek değil — arkasında henüz veri olmayan bir özelliğin önizlemesi.`)
};

const it_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nulla in questa schermata è reale: è l'anteprima di una funzione dietro cui non ci sono ancora dati.`)
};

const pl_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nic na tym ekranie nie jest prawdziwe — to podgląd funkcji, za którą nie stoją jeszcze żadne dane.`)
};

const uk_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ніщо на цьому екрані не є справжнім — це попередній перегляд функції, за якою поки немає даних.`)
};

const hi_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस स्क्रीन पर कुछ भी असली नहीं है — यह उस सुविधा की झलक है जिसके पीछे अभी कोई डेटा नहीं है।`)
};

const ar_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا شيء في هذه الشاشة حقيقي — إنها معاينة لميزة لا توجد خلفها بيانات بعد.`)
};

const ms_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada apa pada skrin ini yang benar — ia pratonton ciri yang belum ada data di sebaliknya.`)
};

const bn_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই পর্দার কিছুই সত্যি নয় — এটি এমন একটি সুবিধার ঝলক যার পেছনে এখনও কোনও তথ্য নেই।`)
};

const zh_tw2_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個畫面上的內容都不是真實的——這是一項尚無資料支撐的功能預覽。`)
};

const zh_hk2_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個畫面上的內容都不是真實的——這是一項尚無資料支撐的功能預覽。`)
};

const ur_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس اسکرین پر کچھ بھی حقیقی نہیں — یہ ایک ایسی خصوصیت کی جھلک ہے جس کے پیچھے ابھی کوئی ڈیٹا نہیں۔`)
};

const fa_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هیچ‌چیز در این صفحه واقعی نیست — این پیش‌نمایش قابلیتی است که هنوز داده‌ای پشتش نیست.`)
};

const sw_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna kilicho halisi kwenye skrini hii — ni onyesho la kipengele ambacho bado hakina data nyuma yake.`)
};

const nl_sample_data_note = /** @type {(inputs: Sample_Data_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niets op dit scherm is echt — het is een voorproefje van een functie waar nog geen gegevens achter zitten.`)
};

/**
* | output |
* | --- |
* | "Nothing on this screen is real — it is a preview of a feature that has no data behind it yet." |
*
* @param {Sample_Data_NoteInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const sample_data_note = /** @type {((inputs?: Sample_Data_NoteInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sample_Data_NoteInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sample_data_note(inputs)
	if (locale === "ja") return ja_sample_data_note(inputs)
	if (locale === "zh") return zh_sample_data_note(inputs)
	if (locale === "es") return es_sample_data_note(inputs)
	if (locale === "pt") return pt_sample_data_note(inputs)
	if (locale === "id") return id_sample_data_note(inputs)
	if (locale === "fr") return fr_sample_data_note(inputs)
	if (locale === "tl") return tl_sample_data_note(inputs)
	if (locale === "vi") return vi_sample_data_note(inputs)
	if (locale === "ko") return ko_sample_data_note(inputs)
	if (locale === "de") return de_sample_data_note(inputs)
	if (locale === "ru") return ru_sample_data_note(inputs)
	if (locale === "tr") return tr_sample_data_note(inputs)
	if (locale === "it") return it_sample_data_note(inputs)
	if (locale === "pl") return pl_sample_data_note(inputs)
	if (locale === "uk") return uk_sample_data_note(inputs)
	if (locale === "hi") return hi_sample_data_note(inputs)
	if (locale === "ar") return ar_sample_data_note(inputs)
	if (locale === "ms") return ms_sample_data_note(inputs)
	if (locale === "bn") return bn_sample_data_note(inputs)
	if (locale === "zh-TW") return zh_tw2_sample_data_note(inputs)
	if (locale === "zh-HK") return zh_hk2_sample_data_note(inputs)
	if (locale === "ur") return ur_sample_data_note(inputs)
	if (locale === "fa") return fa_sample_data_note(inputs)
	if (locale === "sw") return sw_sample_data_note(inputs)
	if (locale === "nl") return nl_sample_data_note(inputs)
	return en_sample_data_note(inputs)
});